import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// location-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate(store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  clearUserNotification(store) {
    store.commit('clearUserNotification')
  },
  updateSelectedUserNotificationList(store, payload) {
    store.commit('updateSelectedUserNotificationList', payload)
  },
  clearSelectedUserNotificationList(store) {
    store.commit('clearSelectedUserNotificationList')
  },
  async addUserNotification(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: store.state.addUserNotification
    }
    await Vue.http.post(URL + '/v2/admin/usernotification/regist', data, config)
  },
  async setUserNotifications(store, payload) {
    store.state.userNotifications = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        pageNo: payload.pageNo,
        count: 20
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/usernotification/list',
      data,
      config
    )
    // 成功
    store.commit('setUserNotifications', response)
  },
  async updateUserNotification(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: store.state.updateUserNotification
    }
    await Vue.http.post(URL + '/v2/admin/usernotification/update', data, config)
  },
  async deleteUserNotifications(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: {
        ids: payload
      }
    }
    await Vue.http.post(URL + '/v2/admin/usernotification/delete', data, config)
  },
  async setDetailUserNotification(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        id: payload.id
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/usernotification/detail',
      data,
      config
    )
    // 成功
    store.commit('setDetail', response)
  },
  async setPost(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          locationDataFlag: false,
          userDataBlankFlag: true
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/user/postlist',
      data,
      config
    )
    // 成功
    store.commit('setPosts', response)
  },
  async setSelectedPost(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [{}]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/post/list',
      data,
      config
    )
    // 成功
    store.commit('setSelectedPosts', response)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/userNotificationModules/actions.js